import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { zip, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductService } from '../../../src/services/productservice';
import { AboutusService } from '../../../src/services/aboutus.service';
import { SearchService } from '../../../src/services/search-service.service';
import { ConstParams } from '../@shared/const.params';
import { InstaService } from '../../../src/services/insta.service';
import { routeParamInfoItems } from '@app/home/home-route-param-info';

export interface IBreadCrumb {
  label: string;
  url: string;
}
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  previousUrl: string = null;
  currrentUrl: string = null;
  public breadcrumbs: any;
  currentUrl: any;
  currentLabel: any;
  menuData: any;
  url: any;
  isPlanYourVisit: boolean;
  arrayMenu: any = [];
  public staticStore: any;
  private staticParams: any;
  static: any;
  staticLabelForProductId: any[] = [];
  public flag: true;
  public refUrl: any = {
    [0]: null,
  };
  public refLabel: any;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private productService: ProductService,
    private aboutusService: AboutusService,
    private searchService: SearchService,
    private insta: InstaService
  ) {}
  ngOnInit(): void {
    zip(this.activatedRoute.paramMap, this.activatedRoute.queryParams)
      .pipe(takeUntil(this.destroy$))
      .subscribe(([paramMap, params]) => {
        const category = paramMap.get('category') ?? paramMap.get('selectedPage');
        //('category.....', category);
        this.currentLabel = this.activatedRoute.routeConfig?.path?.split('/')[0] ?? '';
        const categoryInfo = routeParamInfoItems.find(
          (item) => item.route === this.currentLabel && item.routeParam === category
        );
        const paramsObj: any = {};
        if (categoryInfo?.cat) {
          paramsObj.selectedcat = categoryInfo?.cat;
        }
        if (categoryInfo?.cla) {
          paramsObj.cla = categoryInfo?.cla?.includes(',') ? categoryInfo?.cla?.split(',') : categoryInfo?.cla;
        }
        if (categoryInfo?.['att']) {
          paramsObj.att = categoryInfo?.['att'];
        }
        if (categoryInfo?.tag) {
          paramsObj.tag = categoryInfo?.tag;
        }
        if (categoryInfo?.bannerCat) {
          paramsObj.bannerCat = categoryInfo?.bannerCat;
        }
        if (categoryInfo?.page) {
          paramsObj.page = categoryInfo?.page;
        }
        const ProductId = paramMap.get('ProductId');
        if (ProductId) {
          paramsObj.ProductId = ProductId;
        }
        this.currentUrl = category || ProductId ? paramsObj : params;
        this.staticParams = category || ProductId ? paramsObj : params;
        this.static = this.activatedRoute.snapshot.queryParamMap.get('store');

        this.productService.getFooterMainMenu().then((menuData) => {
          let re = /^([a-z0-9]{5,})$/;
          let paramsData: any = Object.values(this.currentUrl);
          if (re.test(paramsData)) {
            let productKey: any;
            let pDataForGet_Around: any;
            let prName: any;
            this.searchService
              .getViewListingDetails(paramsData.toString())
              .pipe(takeUntil(this.destroy$))
              .subscribe((data) => {
                pDataForGet_Around = data.productTypes;
                productKey = data.productCategoryId;
                prName = data.productName;
                this.createBreadCrumb(
                  this.currentUrl,
                  this.currentLabel,
                  menuData,
                  productKey,
                  pDataForGet_Around,
                  prName
                );
              });
          } else if (this.currentLabel === 'blog' || this.currentLabel === 'blog-details') {
            if (this.currentLabel === 'blog-details') {
              const viewNode = paramMap.get('view_node');
              const pramasObj: any = {};
              if (viewNode) {
                pramasObj.view_node = viewNode;
              }
              let paramsdata = Object.values(pramasObj);

              this.productService.getHighLightsBlobDetails(paramsData.nid, paramsdata.toString()).then((blogData) => {
                this.createBreadCrumb('blog', 'blog', menuData, blogData.bannerTitle);
              });
            } else {
              this.createBreadCrumb('blog', this.currentLabel, menuData);
            }
          } else {
            this.createBreadCrumb(this.currentUrl, this.currentLabel, menuData);
          }
        });
      });
  }

  async createBreadCrumb(
    params: any,
    label: any,
    menusData: any,
    productKey?: any,
    optData?: any,
    prName?: any
  ): Promise<void> {
    this.staticStore = menusData;
    let re = /^([a-z0-9]{5,})$/;
    let paramsData: any = Object.values(params);
    //DW-48 chnages => Getting-Around
    if (
      (menusData[1].name === ConstParams.CAT_PLAN_VISIT &&
        label === ConstParams.PLAN_YOUR_VISIT_ROUTE &&
        paramsData.includes('getting-around')) ||
      (re.test(paramsData) && (productKey == ConstParams.CAT_HIRE || productKey === ConstParams.CAT_TRANS_PORT))
    ) {
      if (!re.test(paramsData)) {
        localStorage.setItem('data', JSON.stringify(paramsData));
      }
      this.arrayMenu = JSON.parse(localStorage.getItem('data'));
      label = menusData[1].name ? menusData[1].name : this.staticStore[1].name;
    }
    //blog
    if (label === 'blog') {
      this.arrayMenu = productKey ? productKey : '';
      label;
    }
    if (
      (menusData[1].name === ConstParams.CAT_PLAN_VISIT &&
        label === ConstParams.PLAN_YOUR_VISIT_ROUTE &&
        (paramsData.includes(ConstParams.CAT_ACCOMM) ||
          paramsData.includes(ConstParams.CAT_TOUR_OPERATOR) ||
          paramsData.includes(ConstParams.CAT_GEN_SERVICE) ||
          paramsData.includes(ConstParams.CAT_INFO_SERVICE) ||
          paramsData.includes(ConstParams.CAT_HIRE))) ||
      (this.staticStore[1].name === ConstParams.CAT_PLAN_VISIT &&
        label === 'listingdetails' &&
        re.test(paramsData) == true &&
        (productKey === ConstParams.CAT_ACCOMM ||
          productKey === ConstParams.CAT_TOUR_OPERATOR ||
          productKey === ConstParams.CAT_GEN_SERVICE ||
          productKey === ConstParams.CAT_INFO_SERVICE ||
          productKey === ConstParams.CAT_HIRE))
    ) {
      this.arrayMenu = menusData[1].children ? menusData[1].children : this.staticStore[1].children;
      label = menusData[1].name ? menusData[1].name : this.staticStore[1].name;
    } else if (
      (menusData[1].name === ConstParams.CAT_PLAN_VISIT && paramsData.includes(ConstParams.CAT_TRANS_PORT)) ||
      (this.staticStore[1].name === ConstParams.CAT_PLAN_VISIT &&
        label === 'listingdetails' &&
        re.test(paramsData) == true &&
        productKey === ConstParams.CAT_TRANS_PORT)
    ) {
      if (!re.test(paramsData)) {
        localStorage.setItem('data', JSON.stringify(paramsData));
      }
      this.arrayMenu = JSON.parse(localStorage.getItem('data'));
      label = menusData[1].name;
    } else if (
      (menusData[2].name === ConstParams.CAT_EXP &&
        label === ConstParams.PLAN_YOUR_VISIT_ROUTE &&
        paramsData.includes(ConstParams.CAT_ATTRACTION)) ||
      paramsData.includes(ConstParams.CAT_FANDDRINK) ||
      paramsData.includes(ConstParams.CAT_DEST_INFO) ||
      paramsData.includes(ConstParams.CAT_TOUR) ||
      (this.staticStore[2].name === ConstParams.CAT_EXP &&
        label === 'listingdetails' &&
        re.test(paramsData) == true &&
        (productKey === ConstParams.CAT_ATTRACTION ||
          productKey === ConstParams.CAT_DEST_INFO ||
          productKey === ConstParams.CAT_FANDDRINK ||
          productKey === ConstParams.CAT_TOUR))
    ) {
      if (!re.test(paramsData)) {
        localStorage.setItem('data', JSON.stringify(paramsData));
      }
      this.arrayMenu = JSON.parse(localStorage.getItem('data'));
      label = menusData[2].name ? menusData[2].name : this.staticStore[2].name;
    } else if (menusData[2].name === ConstParams.CAT_EXP && paramsData.includes('walks-trails')) {
      if (!re.test(paramsData)) {
        localStorage.setItem('data', JSON.stringify(paramsData));
      }
      this.arrayMenu = JSON.parse(localStorage.getItem('data'));
      label = menusData[2].name ? menusData[2].name : this.staticStore[2].name;
    } else if (menusData[2].name === ConstParams.CAT_EXP && paramsData.includes('ATTRACTION')) {
      if (!re.test(paramsData)) {
        localStorage.setItem('data', JSON.stringify(paramsData));
      }
      this.arrayMenu = JSON.parse(localStorage.getItem('data'));
      label = menusData[2].name ? menusData[2].name : this.staticStore[2].name;
    } else if (menusData[2].name === ConstParams.CAT_EXP && paramsData.includes('GENSERVICE')) {
      if (!re.test(paramsData)) {
        localStorage.setItem('data', JSON.stringify(paramsData));
      }
      this.arrayMenu = JSON.parse(localStorage.getItem('data'));
      label = menusData[2].name ? menusData[2].name : this.staticStore[2].name;
    } else if (label === 'islands') {
      let [innerIsland, outerIsland] = menusData[0].children;
      this.arrayMenu = paramsData.includes('innerIslands') ? innerIsland : outerIsland;
      label = menusData[0].name;
    } else if (label === 'island-details' || label === 'island-groups') {
      label = label === 'island-details' ? `Island-Details` : `Island-Groups`;
      this.arrayMenu = paramsData;
    }

    let menudata: any =
      productKey == undefined
        ? await this.getMenu(params, label, this.arrayMenu)
        : await this.getMenu(params, label, this.arrayMenu, productKey, optData, prName);
    this.breadcrumbs = [];
    this.breadcrumbs = menudata;
    //console.log('breadcrumbs.....', this.breadcrumbs);
  }

  //GET menu
  async getMenu(
    currentParams: any,
    currentLabel: any,
    menuParentData: any,
    productKey?: any,
    optionalData?: any,
    prName?: any
  ) {
    let mainData: any = [];
    let re = /^([a-z0-9]{5,})$/;
    let paramsData: any = Object.values(currentParams);
    let productId: any;
    //special interest
    if (paramsData.length === 0) {
      let [params, label] = currentLabel.split('/');
      mainData = this.finalBredCrumb(params, label, null);
    }
    //blog
    if (currentLabel === 'blog') {
      prName = menuParentData;
      mainData = prName
        ? this.finalBredCrumb(currentLabel, currentParams, prName, '', prName)
        : this.finalBredCrumb(currentLabel, '', '', '', '');
    }
    //Search page
    if (
      currentLabel === 'app-search' ||
      currentLabel === 'travel-advisory' ||
      currentLabel === 'mediacenter-gallery' ||
      currentLabel === 'contactus' ||
      currentLabel === 'downloads'
    ) {
      mainData =
        currentLabel === 'travel-advisory'
          ? this.finalBredCrumb(currentLabel, paramsData, null, 'travel-advisory')
          : currentLabel === 'mediacenter-gallery'
          ? this.finalBredCrumb(currentLabel, null, null, 'mediacenter-gallery')
          : currentLabel === 'contactus'
          ? this.finalBredCrumb('Contact Us', null, null, null)
          : currentLabel === 'downloads'
          ? this.finalBredCrumb('Downloads', null, null, null)
          : currentLabel === 'app-googlemaps'
          ? this.finalBredCrumb(currentLabel, null, null, null)
          : this.finalBredCrumb(currentLabel, paramsData, null, 'app-search');
    }
    //Getting Around
    if (
      (currentLabel === ConstParams.CAT_PLAN_VISIT && paramsData.includes('getting-around')) ||
      (re.test(paramsData) && menuParentData.includes('getting-around'))
    ) {
      mainData =
        re.test(paramsData) === true
          ? this.finalBredCrumb(currentLabel, 'getting-around', paramsData, menuParentData, prName)
          : this.finalBredCrumb(currentLabel, 'getting-around', null, menuParentData);
    }
    //Activities
    if (
      (currentLabel === ConstParams.CAT_EXP &&
        (paramsData.includes(ConstParams.CAT_TOUR) ||
          paramsData.includes(ConstParams.CAT_ATTRACTION) ||
          paramsData.includes(ConstParams.CAT_FANDDRINK))) ||
      (re.test(paramsData) &&
        (menuParentData.includes(ConstParams.CAT_TOUR) ||
          menuParentData.includes(ConstParams.CAT_ATTRACTION) ||
          menuParentData.includes(ConstParams.CAT_ATTRACTION) ||
          menuParentData.includes(ConstParams.CAT_FANDDRINK)))
    ) {
      mainData =
        re.test(paramsData) === true
          ? this.finalBredCrumb(currentLabel, menuParentData.toString(), paramsData, menuParentData, prName)
          : this.finalBredCrumb(currentLabel, menuParentData.toString(), null, menuParentData);
    }
    //beaches in Exp
    if (
      (currentLabel === ConstParams.CAT_EXP && paramsData.includes(ConstParams.CAT_DEST_INFO)) ||
      (re.test(paramsData) && menuParentData.includes(ConstParams.CAT_DEST_INFO))
    ) {
      mainData =
        re.test(paramsData) === true
          ? this.finalBredCrumb(currentLabel, ConstParams.CAT_DEST_INFO, paramsData, menuParentData, prName)
          : this.finalBredCrumb(currentLabel, ConstParams.CAT_DEST_INFO, null, menuParentData);
    }
    //walk andTrails In Exp
    if (
      (currentLabel === ConstParams.CAT_EXP && paramsData.includes('walks-trails')) ||
      (re.test(paramsData) && menuParentData.includes('walks-trails'))
    ) {
      mainData =
        re.test(paramsData) === true
          ? this.finalBredCrumb(currentLabel, 'Walks and Trails', paramsData, menuParentData, prName)
          : this.finalBredCrumb(currentLabel, 'Walks and Trails', null, menuParentData);
    }

    //attractions In Exp
    if (
      (currentLabel === 'experience' && paramsData.includes('ATTRACTION')) ||
      (re.test(paramsData) && menuParentData.includes('ATTRACTION'))
    ) {
      mainData =
        re.test(paramsData) === true
          ? this.finalBredCrumb('Experience', ConstParams.CAT_ATTRACTION, paramsData, menuParentData, prName)
          : this.finalBredCrumb('Experience', ConstParams.CAT_ATTRACTION, null, menuParentData);
    }

    //General Services In Exp
    if (
      (currentLabel === ConstParams.CAT_EXP && paramsData.includes('GENSERVICE')) ||
      (re.test(paramsData) && menuParentData.includes('GENSERVICE'))
    ) {
      mainData =
        re.test(paramsData) === true
          ? this.finalBredCrumb(ConstParams.CAT_EXP, 'General Services', paramsData, menuParentData, prName)
          : this.finalBredCrumb(ConstParams.CAT_EXP, 'General Services', null, menuParentData);
    }

    //Transport -Airsv,ferrysvc
    if (
      paramsData.includes(ConstParams.CAT_TRANS_PORT) ||
      paramsData.includes('INTAIRSVC') ||
      paramsData.includes('FERRYSVC') ||
      (re.test(paramsData) && productKey === ConstParams.CAT_TRANS_PORT && !menuParentData.includes('getting-around'))
    ) {
      mainData =
        re.test(paramsData) === true
          ? this.finalBredCrumb(currentLabel, ConstParams.CAT_TRANS_PORT, paramsData, menuParentData, prName)
          : this.finalBredCrumb(currentLabel, ConstParams.CAT_TRANS_PORT, null, menuParentData);
    }

    // EVENT,GENSERVICE,INFO
    if (
      paramsData.includes(ConstParams.CAT_EVENT) ||
      // ||
      // paramsData.includes(ConstParams.CAT_GEN_SERVICE) ||
      // paramsData.includes(ConstParams.CAT_INFO_SERVICE)
      (productKey === ConstParams.CAT_EVENT && re.test(paramsData))
    ) {
      currentLabel =
        re.test(paramsData) && productKey === ConstParams.CAT_EVENT
          ? ConstParams.CAT_EXP
          : !re.test(paramsData) && paramsData.includes(ConstParams.CAT_EVENT)
          ? ConstParams.CAT_EXP
          : currentLabel;

      let optionData: any =
        (paramsData.includes(ConstParams.CAT_EVENT) && !re.test(paramsData)) ||
        (re.test(paramsData) && productKey === ConstParams.CAT_EVENT)
          ? 'Events'
          : (paramsData.includes(ConstParams.CAT_GEN_SERVICE) && !re.test(paramsData)) ||
            (re.test(paramsData) && productKey === ConstParams.CAT_GEN_SERVICE)
          ? 'General Services'
          : (paramsData.includes(ConstParams.CAT_INFO_SERVICE) && !re.test(paramsData)) ||
            (re.test(paramsData) && productKey === ConstParams.CAT_INFO_SERVICE)
          ? 'Information Services'
          : undefined;

      productId = paramsData;
      mainData =
        re.test(paramsData) === true
          ? this.finalBredCrumb(currentLabel, productKey, paramsData, optionData, prName)
          : this.finalBredCrumb(currentLabel, paramsData, null, optionData);
    } else if (
      currentLabel === 'aboutus' ||
      // currentLabel === 'travelinfo' ||
      currentLabel === 'about-us-items' ||
      currentLabel === 'about-us-detail'
    ) {
      //currentLabel  = "About-Us" ;
      mainData =
        currentLabel === 'aboutus'
          ? this.finalBredCrumb('About-Us', currentLabel, null, paramsData)
          : currentLabel === 'travelinfo'
          ? this.finalBredCrumb(currentLabel, currentLabel, null, paramsData)
          : this.finalBredCrumb('About-Us', currentLabel, paramsData);
    }

    //travelInfo with Genservice,InfoService

    if (
      currentLabel === 'travelinfo' ||
      (currentLabel === ConstParams.CAT_PLAN_VISIT &&
        (paramsData.includes(ConstParams.CAT_GEN_SERVICE) || paramsData.includes(ConstParams.CAT_INFO_SERVICE))) ||
      (re.test(paramsData) &&
        (productKey === ConstParams.CAT_GEN_SERVICE || productKey === ConstParams.CAT_INFO_SERVICE))
    ) {
      if (currentLabel === 'travelinfo') {
        localStorage.setItem('data', JSON.stringify(currentLabel));
      }
      this.arrayMenu = JSON.parse(localStorage.getItem('data'));
      let tData: any = menuParentData.map((data: any) => {
        if (data.name === 'Travel Info') {
          return data;
        }
      });
      mainData =
        re.test(paramsData) &&
        (productKey === ConstParams.CAT_GEN_SERVICE || productKey === ConstParams.CAT_INFO_SERVICE)
          ? this.finalBredCrumb(currentLabel, productKey, paramsData, tData.url, prName)
          : !re.test(paramsData) &&
            (productKey === ConstParams.CAT_GEN_SERVICE || productKey === ConstParams.CAT_INFO_SERVICE)
          ? this.finalBredCrumb(currentLabel, paramsData, undefined, tData.url)
          : this.finalBredCrumb(ConstParams.CAT_PLAN_VISIT, paramsData, this.arrayMenu);
    }

    //islands
    if (currentLabel === 'Islands' && (paramsData.includes('innerIslands') || paramsData.includes('outerIslands'))) {
      let { name, url } = menuParentData;
      mainData = this.finalBredCrumb(currentLabel, name, null, url);
    }
    if (currentLabel === 'Island-Details' || currentLabel === 'Island-Groups') {
      let [url] = menuParentData;
      let [data, rest] = paramsData.toString().split('/');
      currentLabel = currentLabel === 'Island-Details' ? `${currentLabel} > ${rest}` : currentLabel;
      mainData =
        currentLabel === 'Island-Groups'
          ? this.finalBredCrumb(currentLabel, 'island-groups', null, paramsData.toString())
          : this.finalBredCrumb(currentLabel, data, null, url);
    }
    //rest of categories and static list
    Array.from(menuParentData).map((childData: any) => {
      if (
        (paramsData.includes(ConstParams.CAT_ACCOMM) == true && childData.name == 'Accommodation') ||
        (childData.name == 'Accommodation' && productKey === ConstParams.CAT_ACCOMM && re.test(paramsData))
      ) {
        productId = paramsData;
        mainData =
          re.test(paramsData) === true
            ? this.finalBredCrumb(currentLabel, childData, productId, '', prName)
            : this.finalBredCrumb(currentLabel, childData);
        this.staticLabelForProductId.push(mainData[0]);
      } else if (
        (paramsData.includes(ConstParams.CAT_TOUR_OPERATOR) == true &&
          (childData.name == 'Operators' || childData.name == 'Tour Operators')) ||
        (childData.name == 'Tour Operators' && productKey === ConstParams.CAT_TOUR_OPERATOR && re.test(paramsData))
      ) {
        productId = paramsData;
        mainData =
          re.test(paramsData) === true
            ? this.finalBredCrumb(currentLabel, childData.name, productId, 'Tour Operators', prName)
            : this.finalBredCrumb(currentLabel, childData.name, null, 'Tour Operators');
      } else if (
        (paramsData.includes(ConstParams.CAT_ATTRACTION) == true && childData.name == 'Attractions') ||
        (childData.name == 'Attractions' && productKey === ConstParams.CAT_ATTRACTION && re.test(paramsData))
      ) {
        productId = paramsData;
        mainData =
          re.test(paramsData) === true
            ? this.finalBredCrumb(currentLabel, childData, productId, '', prName)
            : this.finalBredCrumb(currentLabel, childData);
      } else if (
        (paramsData.includes(ConstParams.CAT_FANDDRINK) == true && childData.name == 'Food & Drinks') ||
        (childData.name == 'Food & Drinks' && productKey === ConstParams.CAT_FANDDRINK && re.test(paramsData))
      ) {
        productId = paramsData;
        mainData =
          re.test(paramsData) === true
            ? this.finalBredCrumb(currentLabel, childData, productId, '', prName)
            : this.finalBredCrumb(currentLabel, childData);
      } else if (
        (paramsData.includes(ConstParams.CAT_DEST_INFO) == true && childData.name == 'Beaches') ||
        (childData.name == 'Beaches' && productKey === ConstParams.CAT_DEST_INFO && re.test(paramsData))
      ) {
        productId = paramsData;
        if (childData.name === 'Beaches') {
          childData.name = 'The Islands';
        }
        mainData =
          re.test(paramsData) === true
            ? this.finalBredCrumb(currentLabel, childData, productId, '', prName)
            : this.finalBredCrumb(currentLabel, childData);
      }
    });

    return mainData;
  }
  finalBredCrumb(fLabel: any, fData?: any, key?: any, opt?: any, prName?: any) {
    let re = /^([a-z0-9]{5,})$/;
    let finalData: any = [];
    if (fLabel === 'special_interest') {
      const sObj: any = {};
      sObj.label = `${ConstParams.CAT_EXP} > ${fLabel}`;
      sObj.url = fLabel;
      if (fData) {
        sObj.key = fData;
        sObj.keyUrl = `${fLabel}>${fData}`;
      }
      finalData = [...finalData, sObj];
    } else if (opt === 'mediacenter-gallery' || fLabel === 'Contact Us' || fLabel === 'app-googlemaps') {
      const blogObj: any = {};
      blogObj.label = fLabel;
      finalData = [...finalData, blogObj];
    } else if (
      fData === ConstParams.CAT_TRANS_PORT ||
      fData === 'getting-around' ||
      fData === ConstParams.CAT_TOUR ||
      fData === ConstParams.CAT_ATTRACTION ||
      fData === ConstParams.CAT_FANDDRINK ||
      fData === ConstParams.CAT_DEST_INFO ||
      fData === 'Walks and Trails' ||
      fData === 'Tour Operators' ||
      fData === 'General Services'
    ) {
      const transObj: any = {};
      let getArround: any = '';

      if (fData === 'getting-around') {
        const optData: any = opt[0] === 'TAXI' || opt[0] === 'TRAIL' ? opt : opt[0];
        optData.map((e: any) => {
          getArround = `${getArround}&cla=${e}`;
        });
        getArround = getArround.replace('&', '');
      }
      transObj.label =
        fData === ConstParams.CAT_TRANS_PORT && opt.includes('INTAIRSVC')
          ? `${fLabel} > Airlines`
          : opt.includes('getting-around')
          ? `${fLabel} > Getting Around`
          : fData === ConstParams.CAT_TOUR || fData === 'TOUR,activity'
          ? `${fLabel} > Activities`
          : fData === ConstParams.CAT_ATTRACTION
          ? `${fLabel} > Attractions`
          : fData === 'General Services'
          ? `${fLabel} > General Services`
          : fData === ConstParams.CAT_FANDDRINK
          ? `${fLabel} > Food & Drinks`
          : fData === ConstParams.CAT_DEST_INFO
          ? `${fLabel} > The Islands`
          : fData === 'Walks and Trails'
          ? `${fLabel} > ${fData}`
          : fData === 'Tour Operators'
          ? `${fLabel} > ${fData}`
          : fLabel;

      transObj.url =
        fData === ConstParams.CAT_TRANS_PORT && opt.includes('INTAIRSVC')
          ? `${ConstParams.PLAN_YOUR_VISIT_ROUTE}/airlines`
          : opt.includes('getting-around')
          ? `${ConstParams.PLAN_YOUR_VISIT_ROUTE}/gettingaround` // `?${getArround}&bannerCat=${opt[1]}`
          : fData === ConstParams.CAT_TOUR
          ? `${ConstParams.EXPERIENCE_ROUTE}/activities`
          : fData === ConstParams.CAT_ATTRACTION
          ? `${ConstParams.EXPERIENCE_ROUTE}/attractions`
          : fData === ConstParams.CAT_FANDDRINK
          ? `${ConstParams.EXPERIENCE_ROUTE}/food-drinks`
          : fData === ConstParams.CAT_DEST_INFO && opt[1] === 'BEACHES' && opt[2] === 'beaches'
          ? `${ConstParams.EXPERIENCE_ROUTE}/beaches`
          : fData === ConstParams.CAT_DEST_INFO
          ? `${ConstParams.EXPERIENCE_ROUTE}/theislands`
          : fData === 'Walks and Trails'
          ? `${ConstParams.EXPERIENCE_ROUTE}/walksandtrails`
          : fData === 'Tour Operators'
          ? `${ConstParams.PLAN_YOUR_VISIT_ROUTE}/touroperators`
          : null;
      if (key != undefined) {
        transObj.key = prName;
        transObj.keyUrl = `/listingdetails/${key.toString()}`;
      }
      finalData = [...finalData, transObj];
    } else if (fLabel === 'blog') {
      const bObj: any = {};
      fLabel = fData === 'blog' ? `Blogs` : null;
      bObj.label = fLabel;
      bObj.url = fData === 'blog' ? `blog` : null;
      if (key != undefined) {
        bObj.key = prName;
        bObj.keyUrl = `/listingdetails/${key.toString()}`;
      }
      finalData = [...finalData, bObj];
    } else if (
      fLabel &&
      fData &&
      fData != 'Tour Operators' &&
      fData != 'blog' &&
      fData.toString() !== 'travel-info' &&
      fData.toString() != ConstParams.CAT_GEN_SERVICE &&
      fData.toString() != ConstParams.CAT_INFO_SERVICE
    ) {
      const Obj1: any = {};
      if (fData === 'activity') {
        fData = 'Activities';
      }
      fLabel =
        fData.toString() === ConstParams.CAT_HIRE && !re.test(fData.toString())
          ? `${fLabel} > Getting Around > ${fData.toString()}`
          : opt === ConstParams.CAT_HIRE && re.test(fData.toString())
          ? `${fLabel} > Getting Around > ${opt}`
          : fData.toString() === ConstParams.CAT_EVENT
          ? `${fLabel} > ${opt}`
          : // : fData.toString() === ConstParams.CAT_GEN_SERVICE || fData.toString() === ConstParams.CAT_INFO_SERVICE
          // ? `${fLabel} > Travel Information > ${opt}`
          fData === 'Inner Islands' || fData === 'Outer Islands'
          ? `${fLabel} > ${fData}`
          : fData === 'aboutus' || fData === 'about-us-items' || fData === 'about-us-detail'
          ? `${ConstParams.CAT_PLAN_VISIT} >` + 'About Seychelles'
          : fData === 'Activities'
          ? `${fLabel} > ${ConstParams.CAT_TOUR} >${fData}`
          : fData === 'islanddetails' || fData === 'island-groups'
          ? fLabel
          : opt === 'app-search' || opt === 'travel-advisory'
          ? fLabel
          : fData === 'TOUR,activity'
          ? `${fLabel} > Activities`
          : `${fLabel} > Where to stay`;
      if (key != undefined) {
        Obj1.key = prName;
        Obj1.keyUrl =
          fData === 'about-us-items' || fData === 'about-us-detail'
            ? `/${fData}?selectedPage=${key.toString()}`
            : `/listingdetails/${key.toString()}`;
      }
      Obj1.label = fLabel;
      Obj1.url =
        fData.toString() === ConstParams.CAT_HIRE && !re.test(fData.toString())
          ? `/${ConstParams.PLAN_YOUR_VISIT_ROUTE}/rentals`
          : opt === ConstParams.CAT_HIRE && re.test(fData.toString())
          ? `/${ConstParams.PLAN_YOUR_VISIT_ROUTE}/rentals`
          : fData.toString() === ConstParams.CAT_EVENT
          ? // fData.toString() === ConstParams.CAT_GEN_SERVICE ||
            // fData.toString() === ConstParams.CAT_INFO_SERVICE
            `/${ConstParams.EXPERIENCE_ROUTE}/events`
          : fData === 'aboutus'
          ? `${fData}/aboutseychelles`
          : fData === 'about-us-items' || fData === 'about-us-detail'
          ? `aboutus/aboutseychelles`
          : fData === 'walks-trails'
          ? `/${ConstParams.EXPERIENCE_ROUTE}/walksandtrails`
          : fData === 'Activities'
          ? `/${ConstParams.EXPERIENCE_ROUTE}/activities`
          : fData === 'Inner Islands' || fData === 'Outer Islands' || opt === 'travel-advisory'
          ? opt
          : fData === 'islanddetails'
          ? `island-details?view_node=${opt}`
          : fData === 'island-groups'
          ? `island-groups?id=${opt}`
          : opt === 'app-search'
          ? `${fLabel}/${fData.toString()}`
          : fData === 'TOUR,activity'
          ? `/${ConstParams.EXPERIENCE_ROUTE}/activities`
          : fData.url;
      finalData = [...finalData, Obj1];
    } else if (
      fData &&
      fData != undefined &&
      (fData.toString() === 'travel-info' ||
        fData.toString() === ConstParams.CAT_GEN_SERVICE ||
        fData.toString() === ConstParams.CAT_INFO_SERVICE)
    ) {
      const trvelObj: any = {};
      if (
        key != undefined &&
        (fData.toString() === ConstParams.CAT_GEN_SERVICE || fData.toString() === ConstParams.CAT_INFO_SERVICE)
      ) {
        trvelObj.key = prName;
        trvelObj.keyUrl = `/listingdetails/${key.toString()}`;
      }
      trvelObj.label =
        fData.toString() === 'travel-info' ||
        fData.toString() === ConstParams.CAT_GEN_SERVICE ||
        fData.toString() === ConstParams.CAT_INFO_SERVICE
          ? `${ConstParams.CAT_PLAN_VISIT} > Travel Information`
          : null;
      trvelObj.url =
        fData.toString() === 'travel-info' ||
        fData.toString() === ConstParams.CAT_GEN_SERVICE ||
        fData.toString() === ConstParams.CAT_INFO_SERVICE
          ? `travelinfo/travelinformation`
          : null;
      if (fData.toString() === ConstParams.CAT_GEN_SERVICE || fData.toString() === ConstParams.CAT_INFO_SERVICE) {
        trvelObj.splKey =
          fData.toString() === ConstParams.CAT_GEN_SERVICE ? `General Services` : `Information Services`;
        const routeParamVal =
          fData.toString() === ConstParams.CAT_GEN_SERVICE ? `generalservices` : `informationservices`;

        trvelObj.splUrl = `${ConstParams.PLAN_YOUR_VISIT_ROUTE}/${routeParamVal}`;
      }
      finalData = [...finalData, trvelObj];
    } else {
      const Obj2: any = {};

      Obj2.label = fLabel === 'wishlist' ? 'WISHLIST' : null;
      Obj2.url = fLabel;
      finalData = [...finalData, Obj2];
    }
    return finalData;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
